/**
 * @generated SignedSource<<037b262271da19830221407ee54b6b92>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CryptoAddressHostType = "KNOWN_VASP" | "SELF_HOSTED" | "UNKNOWN_VASP";
export type OwnerType = "LEGAL_ENTITY" | "NATURAL_PERSON" | "NONE";
export type CreateExternalCryptoAddressInput = {
  address: string;
  destinationTag?: string | null | undefined;
  hostId?: string | null | undefined;
  hostName?: string | null | undefined;
  hostType: CryptoAddressHostType;
  networkId: string;
  ownerIdentifier?: string | null | undefined;
  ownerLegalName?: string | null | undefined;
  ownerType?: OwnerType | null | undefined;
  userOwned: boolean;
};
export type CreateExternalCryptoAddressMutation$variables = {
  input?: CreateExternalCryptoAddressInput | null | undefined;
};
export type CreateExternalCryptoAddressMutation$data = {
  readonly createExternalCryptoAddress: {
    readonly address: string;
    readonly asset: {
      readonly id: string;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
    };
    readonly createdAt: TimeScalar | null | undefined;
    readonly hostName: string | null | undefined;
    readonly hostType: CryptoAddressHostType | null | undefined;
    readonly id: string;
    readonly network: {
      readonly id: string;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
    };
    readonly ownerLegalName: string | null | undefined;
    readonly userOwned: boolean;
  } | null | undefined;
};
export type CreateExternalCryptoAddressMutation = {
  response: CreateExternalCryptoAddressMutation$data;
  variables: CreateExternalCryptoAddressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hostType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hostName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v8 = [
  (v2/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Network",
  "kind": "LinkedField",
  "name": "network",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userOwned",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ownerLegalName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateExternalCryptoAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CryptoAddress",
        "kind": "LinkedField",
        "name": "createExternalCryptoAddress",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": (v8/*: any*/),
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateExternalCryptoAddressMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CryptoAddress",
        "kind": "LinkedField",
        "name": "createExternalCryptoAddress",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "asset",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11f069325ace21e451dddad862740192",
    "id": null,
    "metadata": {},
    "name": "CreateExternalCryptoAddressMutation",
    "operationKind": "mutation",
    "text": "mutation CreateExternalCryptoAddressMutation(\n  $input: CreateExternalCryptoAddressInput\n) {\n  createExternalCryptoAddress(input: $input) {\n    id\n    hostType\n    hostName\n    address\n    network {\n      id\n      name\n      logoUrl\n    }\n    asset {\n      __typename\n      id\n      name\n      logoUrl\n    }\n    userOwned\n    ownerLegalName\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f44704b55ecbfec1c4df6864297c050";

export default node;
